import React, { useState } from 'react';
import TourCard from '../TourCard/TourCard';
import './TourSection.css';

const TourSection = ({ id, title, tours, category, viewAllLink }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  
  const cardsPerPage = 3;
  
  // Get all tours to display in carousel (for smooth scrolling)
  const getAllToursForCarousel = () => {
    return tours;
  };
  
  // Get the visible tours based on current index
  const getVisibleTours = () => {
    if (!showAll) {
      // Show only first 3 tours
      return tours.slice(0, cardsPerPage);
    } else {
      // In carousel mode, we show all tours and use transform for smooth scroll
      return getAllToursForCarousel();
    }
  };
  
  const visibleTours = getVisibleTours();
  const hasMoreTours = tours.length > cardsPerPage;
  const canGoNext = showAll && currentIndex + cardsPerPage < tours.length;
  const canGoPrev = showAll && currentIndex > 0;
  
  const handleViewAll = () => {
    setShowAll(true);
    setCurrentIndex(0);
  };
  
  const handleNext = () => {
    if (currentIndex + cardsPerPage < tours.length && !isAnimating) {
      setIsAnimating(true);
      setCurrentIndex(currentIndex + 1);
      setTimeout(() => setIsAnimating(false), 500);
    }
  };
  
  const handlePrev = () => {
    if (currentIndex > 0 && !isAnimating) {
      setIsAnimating(true);
      setCurrentIndex(currentIndex - 1);
      setTimeout(() => setIsAnimating(false), 500);
    }
  };
  
  const handleClose = () => {
    setShowAll(false);
    setCurrentIndex(0);
  };
  
  // Calculate transform offset for smooth scrolling
  const translateValue = showAll ? (currentIndex * -100) / cardsPerPage : 0;
  
  return (
    <section id={id} className="tour-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{title}</h2>
          {hasMoreTours && !showAll && (
            <button className="view-all-link" onClick={handleViewAll}>
              View All →
            </button>
          )}
          {showAll && (
            <button className="close-carousel" onClick={handleClose}>
              Close ✕
            </button>
          )}
        </div>
        
        <div className={`carousel-wrapper ${showAll ? 'carousel-mode' : ''}`}>
          <button 
            className={`carousel-nav prev ${canGoPrev ? 'visible' : 'hidden'}`} 
            onClick={handlePrev} 
            disabled={isAnimating || !canGoPrev}
          >
            ←
          </button>
          
          <div 
            className="tours-grid"
            style={{
              transform: `translateX(${translateValue}%)`,
              transition: isAnimating ? 'transform 0.5s ease-in-out' : 'none'
            }}
          >
            {visibleTours.map((tour) => (
              <TourCard key={tour.id} tour={tour} />
            ))}
          </div>
          
          <button 
            className={`carousel-nav next ${canGoNext ? 'visible' : 'hidden'}`} 
            onClick={handleNext} 
            disabled={isAnimating || !canGoNext}
          >
            →
          </button>
        </div>
        
        {showAll && (
          <div className="carousel-info">
            Showing {currentIndex + 1} - {Math.min(currentIndex + cardsPerPage, tours.length)} of {tours.length} tours
          </div>
        )}
      </div>
    </section>
  );
};

export default TourSection;
